module.exports = __webpack_public_path__ + "static/media/marine_2.8a461b38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock/mauritius/marine_2.jpg
// module id = 329
// module chunks = 0